import {
  APP_SETTING_DELETE_RESOURCES_BEGIN,
  APP_SETTING_DELETE_RESOURCES_SUCCESS,
  APP_SETTING_DELETE_RESOURCES_FAILURE,
  APP_SETTING_DELETE_RESOURCES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function deleteResources(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_RESOURCES_BEGIN,
    });
    const { projectId, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}resource/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_DELETE_RESOURCES_SUCCESS,
            data: res,
          });
          toast.success('Deleted Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_RESOURCES_FAILURE,
            data: { error: err },
          });
          toast.error('Failed to Delete !', {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteResourcesError() {
  return {
    type: APP_SETTING_DELETE_RESOURCES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_RESOURCES_BEGIN:
      return {
        ...state,
        deleteResourcesPending: true,
        deleteResourcesError: null,
      };

    case APP_SETTING_DELETE_RESOURCES_SUCCESS:
      return {
        ...state,
        deleteResourcesPending: false,
        deleteResourcesError: null,
      };

    case APP_SETTING_DELETE_RESOURCES_FAILURE:
      return {
        ...state,
        deleteResourcesPending: false,
        deleteResourcesError: action.data.error,
      };

    case APP_SETTING_DELETE_RESOURCES_DISMISS_ERROR:
      return {
        ...state,
        deleteResourcesError: null,
      };

    default:
      return state;
  }
}
